//                ___ __  __  _
//    _________  / (_) /_/ /_(_)___  ____ _
//   / ___/ __ \/ / / __/ __/ / __ \/ __ `/
//  (__  ) /_/ / / / /_/ /_/ / / / / /_/ /
// /____/ .___/_/_/\__/\__/_/_/ /_/\__, /
//     /_/                        /____/

/* global */

import Splitting from 'splitting';


// ----------------------------------------------------------------------------
//
// Wrap content of each splitting word in a span for mask reveal animation
//
// ----------------------------------------------------------------------------
const splitInner = (els) => {

  $.each( els, (i, el) => {

    $(el).wrapInner('<span class="word__inner"></span>');

  });
}



// ----------------------------------------------------------------------------
//
// Splitting to HTML
//
// ----------------------------------------------------------------------------
const splitHTML = (el) => {

  // console.log( '{ splitHTML }' );
  // console.log( 'el: %o', el );

  return Splitting.html({
    content: el,
    by: 'lines'
  });

}

export { splitInner, splitHTML };



// WEBPACK FOOTER //
// ./scripts/modules/splitting-setup.js